export default __webpack_public_path__ + "static/media/NewsfeedIcon.b57cb53a.svg";